import { IHomePageListQuery } from "../../models/home-page-list/query";
import {
  IHomePageList,
  IHomePageListDetails,
} from "../../models/home-page-list/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { HomePageListLoading, IInternalState } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: { loading: HomePageListLoading | HomePageListLoading[] };
    }
  | { type: "SET_LIST"; payload: { list: IBaseListingResponse<IHomePageList> } }
  | { type: "SET_DETAILS"; payload: { details?: IHomePageListDetails } }
  | QueryAction<IHomePageListQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
